import { render, staticRenderFns } from "./selectRole.vue?vue&type=template&id=33fd18d6&"
import script from "./selectRole.vue?vue&type=script&lang=ts&"
export * from "./selectRole.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports